 document.addEventListener("DOMContentLoaded", function() {
    let main_wrapper = document.querySelector('.calculator_main');
    let input_wrapper = document.querySelector('.input_main');
    let total_area = document.querySelector(".area_result");
    let full_tiles = document.querySelector("#full_tile_count");
    let corner_tiles = document.querySelector("#corner_result");
    let mortar_tiles = document.querySelector("#mortar_count");
    let adhesive_tiles = document.querySelector("#other_count_1");
    let spacer_tiles = document.querySelector("#other_count_2");
    let primer_tiles = document.querySelector("#other_count_3");
    let sealant_tiles = document.querySelector("#other_count_4");
    console.log('kkk1111111111111')
    main_wrapper.addEventListener('change',function(){
      let area = (this.querySelector('.height_input').value*this.querySelector('.width_input').value).toFixed(2) ;
      let checkbox = this.querySelector('.sugg_pr_name input[type="checkbox"]');
      let full_tiles_cal;
      total_area.innerText = area;
      let cornerTitles = (this.querySelector(".corner_input")).value;
      let corner_result = (this.querySelector(".corner_input")).value * 15.5 ;
      corner_tiles.innerText = Math.ceil(corner_result) ;
      if(full_tiles.closest(".template-product-product-contemporary")){
        full_tiles_cal = (area*65)/30;
        full_tiles.innerText = Math.ceil(full_tiles_cal - ((Math.ceil(corner_result) / 30)));
      }else if(full_tiles.closest(".template-product-glazed-slips-2")){
        console.log('cornerTitles',cornerTitles);
       full_tiles_cal = ((area*60)-cornerTitles)/30;
        full_tiles.innerText = Math.ceil(full_tiles_cal);
        console.log('corner_result',full_tiles.innerText);
      }else{
        full_tiles_cal = (area*63)/35;
        full_tiles.innerText = Math.ceil(full_tiles_cal - ((Math.ceil(corner_result) / 35)));
         console.log('full_tiles.innerText', full_tiles.innerText);
      }

      if(mortar_tiles.closest(".mortar_main").querySelector('input[type="checkbox"]')?.checked){
        if(mortar_tiles.closest(".template-product-product-contemporary")){
            let mortar_count = Math.ceil(area/4);
            mortar_tiles.innerText = mortar_count;
        }else{
          let mortar_count = Math.ceil(area/3);
          mortar_tiles.innerText = mortar_count;
        }
      }
      else{
        let mortar_count = Math.ceil(area/4);
        mortar_tiles.innerText = 0;
      }

       if(sealant_tiles.closest(".result_product").querySelector('input[type="checkbox"]')?.checked){
       if(sealant_tiles.closest(".template-product-product-contemporary")){
        let sealant_count = Math.ceil(area/4);
        sealant_tiles.innerText = sealant_count;
        }
        else{
          let sealant_count = Math.ceil(area/3.5);
          sealant_tiles.innerText = sealant_count;
        }
       }
      else{
        let sealant_count = Math.ceil(area/3.5);
        sealant_tiles.innerText = 0;
      }

      if(adhesive_tiles.closest(".result_product").querySelector('input[type="checkbox"]')?.checked){
      let adhesive_count = Math.ceil(area/4);
      adhesive_tiles.innerText = adhesive_count;
      }
      else{
         let adhesive_count = Math.ceil(area/4);
         adhesive_tiles.innerText = 0;
      }

      if(spacer_tiles.closest(".result_product").querySelector('input[type="checkbox"]')?.checked){
       let spacer_count = Math.ceil(area/4);
       spacer_tiles.innerText = spacer_count;
      }
      else{
       let spacer_count = Math.ceil(area/3);
       spacer_tiles.innerText = 0; 
      }

      if(primer_tiles.closest(".result_product").querySelector('input[type="checkbox"]')?.checked){
        let primer_count = Math.ceil(area/5);
        primer_tiles.innerText = primer_count;
        }
        else{
        let primer_count = Math.ceil(area/5);
        primer_tiles.innerText = 0;
        }
      })

    $(".add_all").on("click", function() {
      let product_id;
      let pr_quantity;
      let items = []
      $(".result_product").each(function(){
         product_id =  parseInt($(this).find(".sugg_pr_quantity").attr("productid")); 
         pr_quantity =  parseInt($(this).find(".pr_quantity").text()); 
        items.push({id:product_id,quantity:pr_quantity})
     }); 
    
     let selected_prID =  parseInt($(".mortar_main").find(":selected").val());  
     let selected_quantity =  parseInt($(".mortar_main").find(".pr_quantity").text());  
     items.push({id:selected_prID,quantity:selected_quantity})
      $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {items},
      dataType: 'json', 
      success: function (data) { 
        rendercart();
       } 
       });
    });
}); 


let calculator_hub = document.querySelectorAll('.hub_calculator_main');
calculator_hub.forEach(function (cal_block) {
    cal_block.addEventListener("change", function () {
        let allInput = this.querySelectorAll(".input_wrapper input");
        let chamberHeight = this.querySelector(".chamber_wrapper .chamber_height");
        let chamberWidth = this.querySelector(".chamber_wrapper .chamber_width");
        let chamberDepth = this.querySelector(".chamber_wrapper .chamber_depth");
        let area_result = this.querySelector(".area_result_wrapper .area_result");
        let adhesive = this.querySelector(".result_product_hub #product_count_1");
        let mortar = this.querySelector(".result_product_hub #product_count_2");
        let primer = this.querySelector(".result_product_hub #product_count_3");
        let sealant = this.querySelector(".result_product_hub #product_count_4");
        let spacer = this.querySelector(".result_product_hub #product_count_5");
        let corner_input = this.querySelector(".corner_input");
        let corner_result = this.querySelector("#corner_tiles");
        let full_tiles_result = this.querySelector("#full_tiles");
        let half_tiles = this.querySelector("#half_tiles");
        let contem_full = this.querySelector("#contem_full");
        let contem_mor = this.querySelector("#contem_mor");
        let chamber_wrapper = this.querySelector(".chamber_wrapper");
        if (allInput.length >= 4) { 
            let full_tiles;
            let R5;
            let half_rqrd;
            let mortar_rqrd;
            let total_area = ((allInput[0].value * allInput[1].value) + (allInput[2].value * allInput[3].value) + (allInput[4].value * allInput[5].value) + (allInput[6].value * allInput[7].value));
            area_result.innerText = total_area ;
            let R15 = total_area / 4.5;
            if(this.classList.contains("Stretcher")){
               R5 = total_area * 63;
               full_tiles = (R5 - (corner_input.value * 15)) / 35 ;
               mortar_rqrd = total_area / 3;
            }else if(this.classList.contains("Flemish")){
              R5 = total_area * 44;
              full_tiles = (R5 - (corner_input.value * 12)) / 35 ;
              half_rqrd =  R5 - (corner_input.value * 12);
              half_tiles.innerText = Math.ceil(half_rqrd);
              mortar_rqrd = total_area / 3;
              console.log("Flemis R5", full_tiles)
            }else if(this.classList.contains("English")){
              R5 = total_area * 33;
              R11 = total_area * 63;
              half_rqrd =  R11 - (corner_input.value * 12);
              half_tiles.innerText = Math.ceil(half_rqrd);
              full_tiles = (R5 - (corner_input.value * 12)) / 35 ;
              mortar_rqrd = total_area / 3;
            }else if(this.classList.contains("Pillars")){
              console.log('cham_width',cham_width)
            }
           
            full_tiles_result.innerText = Math.ceil(full_tiles);
            let corner_rqrd = corner_input.value * 15.5 ;
            corner_result.innerText = Math.ceil(corner_rqrd);
            mortar.innerText = Math.ceil(mortar_rqrd);
            let sealant_rqrd = total_area / 3.5;
            sealant.innerText = Math.ceil(sealant_rqrd);
            let spacer_rqrd = total_area / 4;
            spacer.innerText = Math.ceil(spacer_rqrd);
            let primer_rqrd = total_area / 5;
            primer.innerText = Math.ceil(primer_rqrd);
            let adhesive_rqrd = total_area / 4;
            adhesive.innerText = Math.ceil(adhesive_rqrd);
            let contem_full_ =  (total_area * 65) / 30;
            contem_full.innerText = Math.ceil(contem_full_);
            let contem_mor_ =  total_area / 4;
            contem_mor.innerText = Math.ceil(contem_mor_);
        }
        if (chamber_wrapper){
          let cham_height = this.querySelector(".chamber_height");
          let cham_width = this.querySelector(".chamber_width");
          let cham_depth = this.querySelector(".chamber_depth");
          let breast_height = this.querySelector(".breast_height")
          let breast_width = this.querySelector(".breast_width")
          let breast_depth = this.querySelector(".breast_depth")
          let full_tiles_result = this.querySelector("#full_tiles");
          let adhesive_result = this.querySelector("#product_count_1");
          let mortar_result = this.querySelector("#product_count_2");
          let primer_result = this.querySelector("#product_count_3");
          let spacer_result = this.querySelector("#product_count_4");
          let area_result = this.querySelector(".area_result");
          let corner_result = this.querySelector("#corner_tiles");
          let half_result = this.querySelector("#half_tiles");
          let contem_full_result = this.querySelector("#contem_full");
          let contem_mor_result = this.querySelector("#contem_mor");
          let area;
          let full_area;
          let full_tiles;
          let adhesive_tiles;
          let mortar_tiles;
          let primer_tiles;
          let spacer_tiles;
          let corner_tiles;
          let half_tiles;
          let contem_full;
          let contem_mortar;
          if(this.classList.contains("Breast")){
            area = (((cham_depth.value * cham_height.value) * 2)+(breast_height.value * breast_width.value)+((breast_height.value * chamberDepth.value) * 2));
            full_tiles = (area * 64 - (((cham_height.value*2)+(breast_height.value *2))*15)) / 35 ;
            corner_tiles = ((cham_height.value * 2) + ( breast_height.value * 2)) * 15.5 ;
            corner_result.innerText = Math.ceil(corner_tiles);
            mortar_tiles = area / 3 ;
            primer_tiles = area / 5 ;
            adhesive_tiles = area / 4 ;
            spacer_tiles = area / 4 ;
            contem_full = (area * 64 - (((cham_height.value*2)+(breast_height.value *2))*15)) / 30 ;
            contem_mortar = area / 4 ;
          }else{
             full_area = ( (cham_height.value * cham_width.value) + (cham_width.value * cham_depth.value) + (cham_depth.value * cham_height.value) ) * 63 ;
             area = ((cham_height.value * cham_width.value)+ ((cham_depth.value * cham_height.value) * 2));
             full_tiles = full_area / 35 ;
             adhesive_tiles = area / 4 ;
             mortar_tiles = area / 3 ;
             primer_tiles = area / 5 ;
             spacer_tiles = area / 4 ;
             contem_full = full_area / 30;
             contem_mortar = area / 4 ;
            if(corner_result){
              corner_tiles = cham_height.value * 33 ;
              corner_result.innerText = Math.ceil(corner_tiles);
            }
            if(half_result){
              half_tiles = cham_height.value * 16;
              half_result.innerText = Math.ceil(half_tiles);
            }
          }
          area_result.innerText = Math.ceil(area);
          full_tiles_result.innerText = Math.ceil(full_tiles);
          adhesive_result.innerText = Math.ceil(adhesive_tiles);
          mortar_result.innerText = Math.ceil(mortar_tiles);
          primer_result.innerText = Math.ceil(primer_tiles);
          spacer_result.innerText = Math.ceil(spacer_tiles);
          contem_full_result.innerText = Math.ceil(contem_full);
          contem_mor_result.innerText = Math.ceil (contem_mortar);
        } 
    });
});


